import { render, staticRenderFns } from "./BprSectionValueEditor.vue?vue&type=template&id=e265224a"
import script from "./BprSectionValueEditor.vue?vue&type=script&lang=ts"
export * from "./BprSectionValueEditor.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports